import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout";
import Login from "@/views/loginNew";


Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: { name: "Login" },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forget",
    name: "Forget",
    component: () => import("../views/forget.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/verify.vue"),
  },
  {
    path: "/editinfo",
    name: "editinfo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/editinfo.vue"),
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/paySuccess.vue"),
  },


  {
    path: "/main",
    component: Layout,
    redirect: { name: "home" },
    children: [
      {
        path: "home",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Home.vue"),
      },
      {
        path: "bmRegister",
        name: "bmRegister",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/bmRegister.vue"),
      },
      {
        path: "course",
        name: "course",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/course.vue"),
      },
      {
        path: "evaluation",
        name: "evaluation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/evaluation.vue"),
      },
      {
        path: "specialtyPlan",
        name: "specialtyPlan",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/specialtyPlan.vue"),
      },
      {
        path: "registration",
        name: "registration",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/registration.vue"),
      },
      {
        path: "homework",
        name: "homework",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/homework.vue"),
      },
      {
        path: "exam",
        name: "exam",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/exam.vue"),
      },
      {
        path: "score",
        name: "score",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/score.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/register.vue"),
      },
      {
        path: "info",
        name: "info",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/info.vue"),
      },
      {
        path: "order",
        name: "order",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/order.vue"),
      },
      {
        path: "order2",
        name: "order2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/order2.vue"),
      },
      {
        path: "invoice",
        name: "invoice",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/invoice.vue"),
      },
      {
        path: "log",
        name: "log",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/log.vue"),
      },
      {
        path: "logDetails",
        name: "logDetails",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/logDetails.vue"),
      },
      {
        path: "msg",
        name: "msg",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/msg.vue"),
      },
      {
        path: "msgDetails",
        name: "msgDetails",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/msgDetails.vue"),
      },
      {
        path: "editPw",
        name: "editPw",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/editPw.vue"),
      },
      {
        path: "bmInfo",
        name: "bmInfo",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/bmInfo.vue"),
      },

      // 论文
      {
        path: "thesis2",
        name: "thesis2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/thesis/index.vue"),
      },
      {
        path: "addThesisProposal",
        name: "addThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/addThesisProposal.vue"
          ),
      },
      {
        path: "myThesisProposal",
        name: "myThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/myThesisProposal.vue"
          ),
      },
      {
        path: "mySpotCheck",
        name: "mySpotCheck",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/mySpotCheck.vue"
          ),
      },
      {
        path: "degreeForm",
        name: "degreeForm",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/degreeForm.vue"
          ),
      },
      {
        path: "updateThesisProposal",
        name: "updateThesisProposal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/thesisproposal2/updateThesisProposal.vue"
          ),
      },
      {
        path: "onlineDefenseList",
        name: "onlineDefenseList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/OnlineDefenseList.vue"
          ),
      },
      {
        path: "mySjkh",
        name: "MySjkh",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/thesis/mySjkh.vue"
          ),
      },
      {
        path: "mineBmSelectLocation",
        name: "mineBmSelectLocation",
        component: () =>
          import("../views/mineBm/step1-selectLocation.vue"),
      },
      {
        path: "mineBmSelectMajor",
        name: "mineBmSelectMajor",
        component: () =>
          import("../views/mineBm/step2-selectMajor.vue"),
      },
      {
        path: "mineBmRegisterInfo",
        name: "mineBmRegisterInfo",
        component: () =>
          import("../views/mineBm/step3-registerInfo.vue"),
      },
      {
        path: "mineBmSubmitRegistration",
        name: "mineBmSubmitRegistration",
        component: () =>
          import("../views/mineBm/step4-submitRegistration.vue"),
      },
      {
        path: "courseDetail",
        name: "courseDetail",
        component: () => import("../views/freeStudy/courseDetail.vue"),
      },
      {
        path: "freeStudyPaper",
        name: "freeStudyPaper",
        component: () => import("../views/freeStudy/paper.vue"),
      },
      {
        path: "paperResult",
        name: "paperResult",
        component: () => import("../views/freeStudy/paperResult.vue"),
      },
    ],
  },
  {
    path: "/news",
    name: "news",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/news.vue"),
  },
  {
    path: "/newsDetails",
    name: "newsDetails",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/newsDetails.vue"),
  },
  {
    path: "/courseStudy",
    name: "courseStudy",
    component: () => import("../views/courseStudy.vue"),
  },
  {
    path: "/evaluationPaper",
    name: "evaluationPaper",
    component: () => import("../views/evaluationPaper.vue"),
  },
  {
    path: "/evaluationPaperDetails",
    name: "evaluationPaperDetails",
    component: () => import("../views/evaluationPaperDetails.vue"),
  },
  {
    path: "/paper",
    name: "paper",
    component: () => import("../views/paper.vue"),
  },
  {
    path: "/paperDetail",
    name: "paperDetail",
    component: () => import("../views/paperDetail.vue"),
  },
  {
    path: "/sign",
    name: "Sign",
    component: () => import("../views/sign.vue"),
  },
  {
    path: "/courseDetail",
    redirect: (to) => ({ path: "/main/courseDetail", query: to.query }),
  },
  {
    path: "/freeStudyPaper",
    redirect: (to) => ({ path: "/main/freeStudyPaper", query: to.query }),
  },
  {
    path: "/paperResult",
    redirect: (to) => ({ path: "/main/paperResult", query: to.query }),
  },
  {
    path: "/thesis-edit",
    name: "ThesisEdit",
    component: () =>
      import("../views/thesis/ThesisEdit.vue"),
  },
  {
    path: "/db-waiting-area",
    name: "DbWaitingArea",
    component: () =>import("../views/thesis/dbWaitingArea.vue"),
  },
  {
    path: "/online-defense-room",
    name: "OnlineDefenseRoom",
    component: () => import("../views/thesis/Room.vue"),
  },
  {
    path: "/bm",
    name: "Bm",
    component: () =>
      import("../views/bm/index.vue"),
      children: [
        // 报名流程各步骤页面
        {
          path: "step1-notice",
          name: "BmStepNotice",
          component: () =>
            import("../views/bm/step1-notice.vue"),
        },
        {
          path: "step2-selectLocation",
          name: "BmStepSelectLocation",
          component: () =>
            import("../views/bm/step2-selectLocation.vue"),
        },
        {
          path: "step3-selectMajor",
          name: "BmStepSelectMajor",
          component: () =>
            import("../views/bm/step3-selectMajor.vue"),
        },
        {
          path: "step4-registerInfo",
          name: "BmStepRegisterInfo",
          component: () =>
            import("../views/bm/step4-registerInfo.vue"),
        },
        {
          path: "step5-submitRegistration",
          name: "BmStepSubmitRegistration",
          component: () =>
            import("../views/bm/step5-submitRegistration.vue"),
        },
        {
          path: "step6-payment",
          name: "BmStepPayment",
          component: () =>
            import("../views/bm/step6-payment.vue"),
        },
      ],
  },
];

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => { document.getElementById('app').scrollTo(0,0) },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== "Login" && !window.sessionStorage.getItem("token")) {
    const arr = [
      "Forget", "Sign", "verify", "editinfo", 
      "Bm", 
      "BmStepNotice", "BmStepSelectLocation",
      "BmStepSelectMajor", "BmStepRegisterInfo", 
      "BmStepSubmitRegistration", "BmStepPayment",
      "news", "newsDetails"
    ];
    if (arr.indexOf(to.name) !== -1) {
      next();
    } else {
      next("Login");
    }
  } else {
    next();
  }
});

export default router;
